<template>
  <div class="c-table" ref="designtable">
    <!-- <Spin size="large" fix v-if="loading"></Spin> -->
    <el-table
      ref="table"
      class="common-el-table-styles summary-el-table-styles"
      v-loading="loading"
      :data="data"
      :height="height"
      :summary-method="getSummaries"
      border
      stripe
      show-summary
      @sort-change="sortChange"
    >
      <el-table-column
        v-for="(col, id) in columns"
        :key="id"
        :prop="col.key"
        :label="col.title"
        :show-overflow-tooltip="col.overflow"
        :min-width="col.width"
        :align="col.align"
        :sortable="col.sortable"
        :sort-orders="['descending', 'ascending', null]"
      >
        <template slot-scope="scope">
          <div v-if="col.key === 'control'">
            <el-button type="text" size="small" @click="showClick(scope.row)">消耗明细</el-button>
          </div>
          <span v-else-if="col.key === 'imageStyle'">{{ scope.row[col.key] | toImageStyle }}</span>
          <span v-else-if="col.key === 'imageType'">{{ scope.row[col.key] | toImageType }}</span>
          <span v-else-if="col.key === 'imageCreateTime'">{{ scope.row[col.key] | datetimeToDay }}</span>
          <span v-else-if="col.key === 'imageLauchTime'">{{ scope.row[col.key] | datetimeToDay }}</span>
          <span v-else-if="col.key === 'thirtyDaysAmount'">{{ scope.row[col.key] | toThousands }}</span>
          <div v-else-if="col.key === 'gameNames'" class="m-tooltip">
            <Tooltip
              v-if="scope.row[col.key] && scope.row[col.key] !== '-'"
              placement="top"
              max-width="320"
              :content="scope.row[col.key]"
              transfer
            >
              <span class="m-tooltip-text">{{ scope.row[col.key] }}</span>
            </Tooltip>
            <span v-else>{{ scope.row[col.key] }}</span>
          </div>
          <span v-else-if="col.key === 'bonus'">{{ scope.row[col.key] | toThousands }}</span>
          <span v-else-if="col.key === 'updateTime'">{{ scope.row[col.key] | datetimeToSec }}</span>
          <span v-else-if="col.key === 'createTime'">{{ scope.row[col.key] | datetimeToSec }}</span>
          <span v-else>{{ scope.row[col.key] }}</span>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
import { toThousands } from '@/common/js/filters'
import { formatDate } from '@/common/js/utils'
export default {
  name: 'designTable',
  props: {
    data: {
      type: Array,
      default() {
        return []
      }
    },
    loading: {
      type: Boolean,
      default() {
        return false
      }
    },
    columns: {
      type: Array
    },
    summary: {
      type: Object
    },
    height: {
      type: Number
    }
  },
  methods: {
    showClick(row) {
      const { designerName, imageId, imageName, imageCreateTime } = row
      const upload = formatDate(new Date(imageCreateTime), 'yyyy-MM-dd')
      // 写入面包屑
      this.$store.commit('setIndexRoute', 'listdesign')
      this.$store.commit('setBreadcrumb', [
        {
          title: '设计绩效考核列表',
          href: {
            to: 'listdesign',
            query: {}
          }
        },
        {
          title: '明细'
        }
      ])
      this.$router.push({
        name: 'detaildesign',
        query: {
          id: imageId,
          name: encodeURI(imageName),
          designer: encodeURI(designerName),
          upload: encodeURI(upload)
        }
      })
    },
    getSummaries(param) {
      const { columns } = param
      const sums = []
      const sumColumn = ['projectBonus', 'designBonus', 'bonus', 'thirtyDaysAmount']
      columns.forEach((column, index) => {
        const prop = column.property
        if (index === 0) {
          sums[index] = '合计'
          return
        }
        if (sumColumn.includes(prop)) {
          const summaryVal = this.summary[prop]
          sums[index] = toThousands(summaryVal)
        }
      })
      return sums
    },
    sortChange(column) {
      let orderName
      if (column.order === 'ascending') orderName = 'asc'
      else if (column.order === 'descending') orderName = 'desc'
      this.$emit('on-sort', { sort: column.prop, order: orderName })
    },
    doLayout() {
      if (this.$refs.table) this.$refs.table.doLayout()
    }
  },
  filters: {
    toImageType(cellValue) {
      if (cellValue === 1) return '图片'
      else if (cellValue === 2) return '视频'
    },
    toImageStyle(cellValue) {
      switch (cellValue) {
        case 0:
          return '平面'
        case 1:
          return '2D'
        case 2:
          return '2.5D'
        case 3:
          return '3D'
        case 4:
          return '真人原创'
        case 5:
          return '真人混剪'
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.c-table {
  position: relative;
  background-color: #fff;

  .m-tooltip {
    width: inherit;
    line-height: 1;

    .ivu-tooltip {
      width: 100%;
    }

    .m-tooltip-text {
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      width: 100%;
      display: inline-block;
    }
  }
}
</style>
